import { requestGet as wsRequestGet, requestPost as wsRequestPost } from './_wsApiFetchData';

export async function searchCrawlings(options, language, timeZone, cancelToken) {
  const { filters, skipPages, resultsCount } = options;
  const {
    crawlingId,
    productId,
    executingAt,
    status,
    beforeAt,
    afterAt
  } = filters;

  const params = {
    'Order.By': 'CreatedAt',
    'Order.Direction': 'Desc',
    'Paging.Number': skipPages || 1,
    'Paging.Count': resultsCount,
    CrawlingId: crawlingId || undefined,
    ProductId: productId || undefined,
    ExecutingAt: executingAt || undefined,
    Status: status || undefined,
    BeforeAt: beforeAt || undefined,
    AfterAt: afterAt || undefined
  };

  return wsRequestGet('/admin/crawling/search', language, timeZone, params, cancelToken);
}

export async function getCrawling(id, language, timeZone, cancelToken) {
  return wsRequestGet(`/admin/crawling/${id}`, language, timeZone, null, cancelToken);
}

export async function crawlProduct(options, language, timeZone, cancelToken) {
  const { filters } = options;
  const {
    firstDay,
    daysToCrawl,
    productId
  } = filters;

  const params = {
    FirstDay: firstDay || 0,
    DaysToCrawl: daysToCrawl || 1,
    Id: productId
  };

  return wsRequestPost(`/admin/integration/crawl`, language, timeZone, params, cancelToken);
}
